let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l9vwI")).then(() => parcelRequire('djyES'));